<avi-card class="remote-backup-card">
    <avi-card_header>
        <div class="remote-backup-card__header">
            <div class="remote-backup-card__title">
                {{ l10nKeys.remoteBackupLabel | vtranslate }}
            </div>
            <div *ngIf="remoteBackupEnabled; else elseBlock">
                <div class="remote-backup-card__enabled-label">
                    {{ l10nKeys.enabledDataLabel | vtranslate }}
                </div>
            </div>
            <ng-template #elseBlock>
                <div class="remote-backup-card__deactivated-label">
                    {{ l10nKeys.deactivatedDataLabel | vtranslate }}
                </div>
            </ng-template>
        </div>
    </avi-card_header>
    <avi-card_body>
        <div class="remote-backup-card__row">
            <div class="remote-backup-card__control">
                <avi-input-container noMarginTop>
                    <label aviLabelWithTooltip>
                        {{ l10nKeys.serverLabel | vtranslate }}
                    </label>
                    <input
                        class="sel-version-in-update-card"
                        clrInput
                        [ngModel]="remoteBackupServer"
                        readonly
                    />
                </avi-input-container>
            </div>
        </div>
        <div class="remote-backup-card__row">
            <div class="remote-backup-card__control">
                <avi-input-container noMarginTop>
                    <label aviLabelWithTooltip>
                        {{ l10nKeys.userCredentialsLabel | vtranslate }}
                    </label>
                    <input
                        class="sel-version-in-update-card"
                        clrInput
                        [ngModel]="remoteBackupUserCredentials"
                        readonly
                    />
                </avi-input-container>
            </div>
        </div>
        <div class="remote-backup-card__row">
            <div class="remote-backup-card__control">
                <avi-input-container noMarginTop>
                    <label aviLabelWithTooltip>
                        {{ l10nKeys.directoryLabel | vtranslate }}
                    </label>
                    <input
                        class="sel-version-in-update-card"
                        clrInput
                        [ngModel]="remoteBackupDirectory"
                        readonly
                    />
                </avi-input-container>
            </div>
        </div>
    </avi-card_body>
</avi-card>
